/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateFirebaseAccountForLeadResult interface.
 */
export function instanceOfCreateFirebaseAccountForLeadResult(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    return true;
}
export function CreateFirebaseAccountForLeadResultFromJSON(json) {
    return CreateFirebaseAccountForLeadResultFromJSONTyped(json, false);
}
export function CreateFirebaseAccountForLeadResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
    };
}
export function CreateFirebaseAccountForLeadResultToJSON(json) {
    return CreateFirebaseAccountForLeadResultToJSONTyped(json, false);
}
export function CreateFirebaseAccountForLeadResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
    };
}
